import { render, staticRenderFns } from "./MarginBySiteByDestiTable.vue?vue&type=template&id=0c8e4ab1"
import script from "./MarginBySiteByDestiTable.vue?vue&type=script&lang=js"
export * from "./MarginBySiteByDestiTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports